import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { CourseCertificate, CourseCertificatePrint, PathCertificatePrint } from "../../Models/Certificates";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class PrintedCertificatesVM extends InterActive{
    private courses:CourseCertificatePrint[] = []
    private paths:PathCertificatePrint[] = []

    public get Courses():CourseCertificatePrint[] { return this.courses }
    public get Paths():PathCertificatePrint[] { return this.paths }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getAllPrinted()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.courses = response.data.data.courses
                                this.paths = response.data.data.paths
                                this.update()
                            } else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }
    public async getMoreCourses(props:{id?:string,search?:string,initial:boolean}){
        try{
            const response = await ApiRequest.getMorePrintedCourses(props.id, props.search)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        if(response.data.data.length > 0 ){
                            this.courses =props.initial?response.data.data: [...this.courses, ...response.data.data]
                            this.update()
                            return true
                        }
                    }
                    else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
        return false 
    }
    public async getMorePrintedPaths(props:{id?:string,search?:string,initial:boolean}){
        try{
            const response = await ApiRequest.getMorePrintedPaths(props.id, props.search)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        if(response.data.data.length > 0 ){
                            this.paths =props.initial?response.data.data: [...this.paths, ...response.data.data]
                            this.update()
                            return true
                        }
                    }
                    else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                }else Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:"danger" , title:'فشل العملية' , body:'خطأ غير معروف .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
        return false 
    }
    
}